import BaseAPI from '@/apis/base/baseApi';

class WebsiteDeepTaskResultAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteDeepTaskResult';
}

export default new WebsiteDeepTaskResultAPI();
